import styled from 'styled-components'
import { hFlex } from '../../../../../../../../../../Styles/style-helpers'
import { H6 } from '../../../../../../../../../../Styles/typography'

export const SubmissionEl = styled.div`
  margin-top: 1em;
  padding: 0 1em;
  ${hFlex};
  align-items: flex-start;
  margin-bottom: 1em;

  &:first-of-type {
    margin-top: 2.5em;
  }

  &:last-of-type {
    margin-bottom: 5em;
  }

  & > svg {
    font-size: 1.5em;
  }

  & > ${H6} {
    margin-left: 1em;
    width: 100%;
    line-height: 1.3;
  }

  .new {
    background: red;
    padding: 0.25em 0.75em;
    border-radius: 10em;
    letter-spacing: 0.025em;
  }
`
